import { render, staticRenderFns } from "./PuntosGestionCreate.vue?vue&type=template&id=490fdaef"
import script from "./PuntosGestionCreate.vue?vue&type=script&lang=js"
export * from "./PuntosGestionCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports